<template>
  <div class="severity-cell">
    <div class="severity" :style="style">
      {{ value }}
    </div>
  </div>
</template>

<script>
import actionToTakeTable from '@/mixins/actionToTakeTable';

export default {
  name: 'SeverityTableCell',
  mixins: [actionToTakeTable],
  computed: {
    colorsForLevels() {
      if (this.item[this.columnName].toLowerCase() === 'informative') {
        return { color: '#4D9FEB' };
      }
      if (this.item[this.columnName].toLowerCase() === 'critical') {
        return { color: '#DF399F' };
      }
      if (this.item[this.columnName].toLowerCase() === 'high') {
        return { color: '#FF7F00' };
      }
      if (this.item[this.columnName].toLowerCase() === 'medium') {
        return { color: '#2459D5' };
      }
      return { color: '#2BAF69' };
    },
    columnName() {
      return this.column.name;
    },
    isScoreCell() {
      return false; // this.column.name.toLowerCase().indexOf('score') > 0;
    },
    value() {
      return this.item[this.columnName];
    },
    style() {
      return this.isScoreCell
        ? {
          ...this.color,
          backgroundColor: this.hexToRgba(this.color.color, 0.1),
          fontSize: '14px',
          minWidth: '37px',
          minHeight: '25px',
          borderRadius: '3px',
        } : {
          backgroundColor: this.hexToRgba(this.colorsForLevels.color, 0.1),
          ...this.colorsForLevels,
        };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.severity-cell {
  align-items: center;
  display: flex;
  justify-content: left;
  margin-left: $space-0-5;
}

.severity {
  text-transform: capitalize;
  align-items: center;
  display: flex;
  font-family: $font-family-bold;
  font-size: $font-size-base;
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);
  justify-content: center;
  padding: $space-0-5 $space-1;
  border-radius: $radius-md;
  width: rem(90);
}
</style>
